{% block sw_cms_slot_content %}
    {% parent %}

    {% block swag_cms_extensions_form_editor_modal %}
        <swag-cms-extensions-form-editor-modal
            v-if="showFormCreationModal"
            @modal-close="onCloseCreateFormModal"
        />
    {% endblock %}
{% endblock %}

{% block sw_cms_slot_content_settings_modal %}
    <template v-if="showElementSettings">
        <swag-cms-extensions-form-editor-modal
            v-if="slotHasFormExtension"
            @modal-close="onCloseEditFormModal"
        />

        <mt-modal-root
            :is-open="!slotHasFormExtension"
            @change="onSettingsModalClose"
        >
            <mt-modal
                class="sw-cms-slot__config-modal"
                :title="modalTitle"
            >
                {% block sw_cms_slot_content_settings_modal_component %}
                    <component
                        :is="elementConfig.configComponent"
                        :element-data="elementConfig"
                        ref="elementComponentRef"
                        v-model:element="element"
                        @form-template-id-change="onFormTemplateIdChange"
                    />
                {% endblock %}

                {% block sw_cms_slot_content_settings_modal_footer %}
                    <template #footer>
                        <div class="sw-cms-slot-content-settings-modal__footer">
                            {% block sw_cms_slot_content_settings_modal_action_confirm %}
                                {% block swag_cms_extensions_modal_action_cancel %}
                                    <mt-button v-if="isElementTypeCustomForm"
                                               variant="secondary"
                                               @click="onSettingsModalClose">
                                        {{ $tc('global.default.cancel') }}
                                    </mt-button>
                                {% endblock %}

                                {% block swag_cms_extensions_modal_action_confirm %}
                                    <mt-button variant="primary"
                                               @click="onPrimaryConfirm">
                                        {{ primaryActionText }}
                                    </mt-button>
                                {% endblock %}
                            {% endblock %}
                        </div>
                    </template>
                {% endblock %}
            </mt-modal>
        </mt-modal-root>
    </template>
{% endblock %}
